(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("layer-blending-mode", [], factory);
	else if(typeof exports === 'object')
		exports["layer-blending-mode"] = factory();
	else
		root["layer-blending-mode"] = factory();
})(self, function() {
return 